import React from "react";

const NoCardsItem = ({}) => {
    return (
        <div className={`plan-item credit-card-div selected-credit-card lightyellow`}
             data-testid={'noPaymentMethodAttachedDiv'}
             style={{width: "fit-content", marginTop: '1em' }}>
            <img alt={"Card"}
                 className={`credit-card-img`}
                 src={'../images/creditAlert.png'}/>
            <div className={"credit-card-text"}>
                <div className={`plan-sub-title`}>{i18n.payments.noPaymentMethodAttached}</div>
                <span className={`plan-sub-details`} style={{width: "200px"}}>
                    {i18n.payments.noPaymentMethodAttachedDetail}
                </span>
            </div>
        </div>
    );
}

export default NoCardsItem;